import React from 'react';
import { useAccounts } from '../hooks';
import AccountList from '../components/AccountList';

const Accounts: React.FC = () => {
  const {
    comptes,
    loading,
    addCompte,
    editCompte,
    removeCompte,
  } = useAccounts();

  return (
    <div className="space-y-2">
      <AccountList
        accounts={comptes}
        loading={loading}
        onAddAccount={addCompte}
        onEditAccount={editCompte}
        onDeleteAccount={removeCompte}
      />
    </div>
  );
};

export default Accounts;
